import { useState, useEffect, useCallback } from 'react';

export default function useNavState() {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);

  const leave = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('click', leave);
    }

    return () => {
      document.removeEventListener('click', leave);
    };
  }, [isOpen, leave]);

  return [isOpen, open];
}
